import * as S from './styles';
import globals from '../../../Globals.json';
import PanelLoading from '../../Loading/PanelLoading';
import useGetData from '../../../Services/useGetData';
import { useAppSelector } from '../../../redux/store';
import Format from '../../../Services/Format';
import { useHistory } from 'react-router';
import { BsArrowDownCircleFill, BsArrowUpCircleFill } from "react-icons/bs";
import { buildDashboardQuery } from '../dateFilters';

interface Transacao {
  description: string;
  due_date: string;
  amount: string;
}

export function IncomeAndExpense({
  type,
  startDate,
  endDate,
}: {
  type: 'receitas' | 'despesas';
  startDate?: string;
  endDate?: string;
}) {
  const router = useHistory();
  const { storeActive } = useAppSelector(
    ({ storeMeReducer }) => storeMeReducer.value
  );

  // store_id é obrigatório neste endpoint — sem ele a API responde 400.
  const { data, isLoading } = useGetData({
    path: globals?.api?.incomeExpense,
    query: buildDashboardQuery({ storeId: storeActive?.id, startDate, endDate }),
    enabled: !!storeActive?.id,
  });

  const filteredData: Transacao[] =
    type === 'receitas' ? data?.receitas : data?.despesas;

  const handleNew = () => {
    type === 'receitas'
      ? router.push(`/dashboard/financeiro/transacoes-receitas`)
      : router.push(`/dashboard/financeiro/transacoes-despesas`);
  };

  return (
    <S.Container>
      <div className="menu-top">
        <h3>
          {type === 'receitas' ? (
            <BsArrowUpCircleFill size={20} color="#16a34a" />
          ) : (
            <BsArrowDownCircleFill size={20} color="#dc2626" />
          )}
          {type}
        </h3>
        <button onClick={handleNew}>
          {type === 'receitas' ? 'Nova Receita' : 'Nova Despesa'}
        </button>
      </div>
      <p className="subtitle">
        {startDate && endDate
          ? <>Vencimento no período <strong>selecionado</strong></>
          : <>Mostrando os <strong>últimos lançamentos</strong></>}
      </p>

      <div className="wrapper">
        {isLoading ? (
          <PanelLoading />
        ) : filteredData?.length > 0 ? (
          filteredData.map((item: Transacao, index: number) => (
            <div key={index} className="list">
              <div className="info">
                <span className="description">{item.description}</span>
                <span className="due-date">
                  {Format.formatDate(item.due_date)}
                </span>
              </div>
              <span
                className={`amount ${type === 'receitas' ? 'amount-green' : 'amount-red'
                  }`}
              >
                {Format.formatCurrencyBr(item.amount)}
              </span>
            </div>
          ))
        ) : (
          <div className="not-data">Ainda não há {type} cadastradas!</div>
        )}
      </div>
    </S.Container>
  );
}
